export default __webpack_public_path__ + "static/media/05.4d5aabe5.jpg";